module.exports = __webpack_public_path__ + "img/denmark-lung-cancer-female.b48e45c3.png";